import './footer.scss';
import { FadeIn } from '../fadein';
import { FormattedMessage } from 'react-intl';
import Pix from './logo-pix.png';
import Jogue from './logo-jogue.png';
import Lost from '../../asserts/images/losterido.png';
import Doublebet_text from '../../asserts/images/doublebet_text.png';
import Mourgames from '../../asserts/images/gamelogo.png';
export const Footer = () => {
	return (
		<div className="footer-wrapper">
			<div className="logo">
				<img src={Mourgames} alt="" />
				{/* <img src={Doublebet_text} alt="" /> */}
			</div>
			<div className="footer-inner">
				<div className="container">
					<div className="copyright">
						<div className="Mourgames">
							{`Mourgames é um site de entretenimento online que oferece aos seus usuários uma experiência única de apostas esportivas. Este site é operado por Doublebet LTDA Con CNPJ 35.754.684/0001-00 , entidade devidamente autorizada pelo Município de Bodó/RN por meio do Termo de Credenciamento e Autorização N° 001/2024.`}
						</div>
						<div>Copyright © 2025 - Todos direitos reservado</div>
					</div>
					<div className="menu-list">
						{/* <div>Termos de Uso</div>
						<div>Política de Privacidade</div>
						<div>Política de Cookies</div> */}
						{/* <div
							onClick={() => {
								window.open(
									'https://www.diariomunicipal.com.br/femurn/pesquisar?busca_avancada%5Bpage%5D=&busca_avanca[…]U3HAAeqEfKALzNorl32SxwmKjZnlQLIhqOGZ4mwqCi8vyBS11rRQsJg'
								);
							}}
						>
							Consulta de licença
						</div> */}
					</div>
				</div>
			</div>
			<div className="line"></div>
			<div className="img-list">
				<div className="img-item lost">
					<img src={Lost} alt="lost" />
				</div>
				<div className="img-item pix">
					<img src={Pix} alt="pix" />
				</div>
				<div className="img-item jogue">
					<img src={Jogue} alt="Jogue" />
				</div>
			</div>
			<div className="contato">Contato:service@mourgames.com</div>
		</div>
	);
};
